export default __webpack_public_path__ + "static/media/9_1_logo.a362033a.png";